var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlackhole(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 916,
    height: 807,
    viewBox: "0 0 916 807",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_n_652_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M175.498 101.707C296.44 -6.07359 468.085 -20.7003 602.547 52.7657C602.54 52.7527 602.534 52.7395 602.527 52.7265C602.205 52.0948 602.838 51.4245 603.483 51.7191C616.555 57.695 693.341 92.2796 722.646 93.7046C781.109 96.5468 895.431 14.0105 914.187 0.152049C914.832 -0.323913 915.628 0.407965 915.239 1.10897C880.258 64.1384 770.06 166.065 745.228 188.196C744.856 188.527 744.47 188.832 744.072 189.112C834.061 339.656 807.588 537.616 671.809 658.621C537.662 778.169 341.133 783.114 202.16 680.357C199.125 678.113 194.955 678.187 192.072 680.621C149.373 716.656 59.7354 787.707 0.99052 806.585C0.26551 806.818 -0.315788 805.998 0.191676 805.431C14.3426 789.625 108.93 681.359 105.966 614.649C105.217 597.8 94.9195 565.031 84.1162 534.783C77.2315 519.677 71.416 504.224 66.6641 488.534C63.4264 480.346 60.8895 474.113 59.5696 470.899C59.3003 470.242 59.9824 469.655 60.5709 469.955L60.7579 470.071C61.1155 470.255 61.5531 469.932 61.4509 469.517C29.5316 339.65 68.7076 196.877 175.498 101.707ZM626.779 256.467C592.489 284.383 506.633 354.923 452.247 405.215C391.202 461.665 301.705 545.455 270.991 574.234C267.441 577.56 267.708 583.225 271.611 586.13C365.169 655.771 497.822 652.613 588.303 571.979C678.927 491.216 697.193 359.514 638.408 258.522C635.997 254.38 630.496 253.441 626.779 256.467ZM254.308 197.201C150.816 289.431 141.687 448.095 233.917 551.587C235.876 553.785 237.866 555.942 239.884 558.055C242.687 560.99 247.219 561.26 250.387 558.725C288.045 528.59 381.515 453.085 444.316 396.314C500.198 345.797 578.654 269.436 613.914 234.883C616.825 232.031 617.099 227.47 614.496 224.335C612.609 222.063 610.675 219.814 608.694 217.592C516.464 114.1 357.8 104.971 254.308 197.201Z",
    fill: "url(#paint0_linear_652_2)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_n_652_2",
    x: 0,
    y: 0,
    width: 915.342,
    height: 806.626,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feTurbulence", {
    type: "fractalNoise",
    baseFrequency: "4 4",
    stitchTiles: "stitch",
    numOctaves: 3,
    result: "noise",
    seed: 3342
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "noise",
    type: "luminanceToAlpha",
    result: "alphaNoise"
  }), /*#__PURE__*/React.createElement("feComponentTransfer", {
    in: "alphaNoise",
    result: "coloredNoise1"
  }, /*#__PURE__*/React.createElement("feFuncA", {
    type: "discrete",
    tableValues: "1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 "
  })), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "shape",
    in: "coloredNoise1",
    result: "noise1Clipped"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgba(0, 0, 0, 0.25)",
    result: "color1Flood"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "noise1Clipped",
    in: "color1Flood",
    result: "color1"
  }), /*#__PURE__*/React.createElement("feMerge", {
    result: "effect1_noise_652_2"
  }, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shape"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "color1"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_652_2",
    x1: 182.96,
    y1: 95.0575,
    x2: 679.27,
    y2: 651.971,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0037FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0385FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackhole);
export default __webpack_public_path__ + "static/media/blackhole.95de248b42ee937169064ab0e79b153f.svg";
export { ForwardRef as ReactComponent };